import { useMutation, useQueryClient } from "react-query";

import { addStore, editStore } from "./index";

export const useAddStore = () => {
  const queryClient = useQueryClient();

  return useMutation(["add-store"], addStore, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["get-stores"] });
    },
  });
};

export const useEditStore = () => {
  const queryClient = useQueryClient();

  return useMutation(["edit-store"], editStore, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["get-stores"] });
    },
  });
};
